@import "../../../containers/styles.module.scss";

.container__form {
  @media (min-width: $size-md) {
    width: 324px;
  }
}

.btn_backToMyAccount {
  @media (min-width: $size-sm) {
    width: 175px !important;
  }
}
